import * as Proxy from './Proxy'

export default (function () {
    const baseUrl = "/paymentlobby/api/CustomerProtection/";
    return {
        GetCustomerProtectionActivity(request) {
            var url = baseUrl + "GetCustomerProtectionActivity";
            return Proxy.Post(url, request);
        },
        CloseProtection(request) {
            var url = baseUrl + "CloseProtection";
            return Proxy.Post(url, request);
        },
        InsertCustomerProtectionActivity(request) {
            var url = baseUrl + "InsertCustomerProtectionActivity";
            return Proxy.Post(url, request);
        },
        GetProtectionReasons(request) {
            var url = baseUrl + "GetProtectionReasons";
            return Proxy.Post(url, request);
        },
        GetPermissionsObjects(request) {
            var url = baseUrl + "GetPermissionsObjects";
            return Proxy.Post(url, request);
        },
    };
})()